import { AppBar, Box, Button, IconButton, Toolbar, Tooltip } from '@mui/material'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import TableChartIcon from '@mui/icons-material/TableChart'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { UserAuthStatus, useAuth } from '../../hooks/context/UserAuthContext'
import HeaderLogo from './HeaderLogo'

const Header = () => {
  const { user } = useAuth()
  return (
    <>
      <AppBar
        sx={{
          backgroundColor: '#ffffff',
          color: '#111111',
        }}
      >
        <Toolbar>
          <HeaderLogo />
          <div>HT Tyre Warranty</div>
          <Box flexGrow={1} />
          {user && (
            <Tooltip title='Warranty Registrations'>
              <IconButton component={RouterLink} to='/dashboard'>
                <TableChartIcon color='primary' />
              </IconButton>
            </Tooltip>
          )}
          {user?.isAdmin ? (
            <Button component={RouterLink} to='/admin'>
              Admin
            </Button>
          ) : (
            user && (
              <Tooltip title='Register Warranty'>
                <IconButton component={RouterLink} to='/register-warranty'>
                  <NoteAddIcon color='primary' />
                </IconButton>
              </Tooltip>
            )
          )}

          <UserAuthStatus />
        </Toolbar>
      </AppBar>

      {/* Padding */}
      <Toolbar />
    </>
  )
}

export default Header
